import React, { useState } from 'react';
import { SelectorContentTabs } from '../custom/SelectorContentTabs';
import { MyBetsTable } from './components/MyBetsTable';
import { MobileSteps } from '../Steps/Steps';
import { NoAuthOrMoneyModal } from '../modal/noAuthOrMoneyModal/NoAuthOrMoneyModal';
import { ModalType } from '../modal/noAuthOrMoneyModal/ModalType';

export type tab = 'allBets' | 'calculated' | 'notCalculated';

export const MyBets: React.FC = () => {
    const [actualDate, setActualDate] = React.useState<Date>(new Date());
    const [currentTab, setCurrentTab] = useState<tab>('allBets');

    const tabValues = {
        allBets: undefined,
        calculated: true,
        notCalculated: false
    };

    return (
        <>
            <SelectorContentTabs
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                date={actualDate}
                setDate={setActualDate}
            />
            <div className="max-tablet:hidden">
                <MyBetsTable
                    calculated={tabValues[currentTab]}
                    actualDate={actualDate}
                    currentTab={currentTab}
                />
            </div>
            <div className="tablet:hidden">
                <MobileSteps
                    calculated={tabValues[currentTab]}
                    actualDate={actualDate}
                    currentTab={currentTab}
                />
            </div>
            <NoAuthOrMoneyModal modalType={ModalType.MY_BETS}/>
        </>
    );
};
export { MyBets as default };
